// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".input-password-custom.theme--dark .v-input__slot,.input-password-custom.theme--light .v-input__slot{background:#fff!important}.input-password-custom.theme--dark.v-input--is-disabled .v-input__slot,.input-password-custom.theme--light.v-input--is-disabled .v-input__slot{background:#f5f5f5!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
